import { ezitxt } from "./ezitxt";
import type { Theme } from "./types";

// Registry of available brand themes. To add one:
//   1. create src/themes/<id>/ with root.<id>.css (tokens) + a Logo component + index.ts
//   2. register it below.
// The active theme is selected at build time via VITE_THEME (defaults to "ezitxt").
const THEMES: Record<string, Theme> = {
  ezitxt,
};

const activeId = (import.meta.env.VITE_THEME as string) || "ezitxt";
export const theme: Theme = THEMES[activeId] ?? ezitxt;

export type { Theme, LogoProps } from "./types";
